/*global __CLIENT__*/
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ModalActions } from '../actions/modal';
import { ProjectActions } from '../actions/project';
import ProjectCardsContainer from '../components/ProjectCardsContainer';
import ToastContainer from '../components/ToastContainer';
import FullScreenModal from '../components/modals/FullScreenModal';
import NavBarNew from '../components/toolbars/NavBarNew';
import { showModalSelector } from '../reducers/modal';
import immutableCreatorSelector from '../selectors/immutableCreatorSelector';
import { AuthActions } from '../actions/auth';
import '../styles/Dashboard.css';

class Dashboard extends React.Component {
  static propTypes = {
    showModal: PropTypes.bool,
  };

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  toggleModal() {
    this.context.store.dispatch(
      ModalActions.toggleModal({
        name: 'CreateProjectModal',
      }),
    );
  }

  componentDidMount() {
    this.context.store.dispatch(AuthActions.getMeProjects());
  }

  render() {
    return (
      <div className="main-container">
        <ToastContainer />
        <div className="dashboard-container">
          <NavBarNew />
          <div className="row" style={{ marginLeft: 50 }}>
            <div className="col-xs-12 projects p-3" style={{ width: '100%' }}>
              <div className="row">
                <h2 className="section-header pull-left">Projects</h2>
                <div className="button-group pull-left">
                  {/*<button
                    className="btn btn-primary btn-sm"
                    type="button"
                    onClick={::this.toggleModal}
                  >
                    <i className="fa fa-plus"></i> New Project
                  </button>
                  */}
                </div>
              </div>
              <div className="row box-container">
                <ProjectCardsContainer />
              </div>
            </div>
          </div>
        </div>
        <FullScreenModal />
      </div>
    );
  }
}

const ProjectsSelector = immutableCreatorSelector(
  [showModalSelector],
  showModal => {
    return {
      activities: [],
      showModal,
    };
  },
);

// @connect(state => ({
//   activities: [],
//   showModal: state.modal.get('showModal'),
// }))
@connect(ProjectsSelector)
export default class DashboardContainer extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func,
  };

  render() {
    const { showModal, dispatch } = this.props;
    return (
      <Dashboard
        showModal={showModal}
        {...bindActionCreators(ProjectActions, dispatch)}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Projects.js